var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginMove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.9998 30C23.2707 30 29.9995 23.2709 29.9995 14.9999C29.9995 6.72906 23.2707 0 14.9998 0C6.72892 0 0 6.72906 0 14.9999C0 23.2709 6.72892 30 14.9998 30ZM14.9998 2.05338C22.1384 2.05338 27.9461 7.86116 27.9462 14.9999C27.9462 22.1387 22.1386 27.9465 14.9998 27.9466C7.86116 27.9465 2.05352 22.1387 2.05352 14.9998C2.05352 7.86129 7.86116 2.05338 14.9998 2.05338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.9856 21.4246C13.3866 21.8254 14.0367 21.8252 14.4375 21.4246C14.8386 21.0235 14.8386 20.3735 14.4374 19.9724L10.4921 16.0273L21.9167 16.0262C22.4837 16.0261 22.9433 15.5665 22.9433 14.9993C22.9431 14.4323 22.4836 13.9728 21.9166 13.9728L10.4916 13.9739L14.4378 10.028C14.8387 9.62708 14.8387 8.97684 14.4378 8.57602C14.2372 8.37561 13.9745 8.27527 13.7117 8.27527C13.449 8.27527 13.1863 8.37561 12.9858 8.57588L7.28708 14.2744C7.09447 14.4669 6.98633 14.7279 6.98633 15.0004C6.98647 15.2728 7.09461 15.5337 7.28722 15.7266L12.9856 21.4246Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginMove);
export default __webpack_public_path__ + "static/media/loginMove.c1e9bbcfc578c48822b99a9d82f3daf2.svg";
export { ForwardRef as ReactComponent };